import React, { useMemo } from 'react';
import { getResumeGeoPoint } from '@cp/entities/resume';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { VacancyView, VacancyViewProps } from 'src/entities/vacancy';
import { CatalogItemMap } from 'src/entities/catalog';

export default (props: VacancyViewProps) => {
  const isLoggedIn = useIsLoggedIn();
  const map = useMemo(() => props.data && <CatalogItemMap location={getResumeGeoPoint(props.data)} />, [props.data]);
  return <VacancyView disableInfo={!isLoggedIn} map={map} {...props} />;
};
